import { render, staticRenderFns } from "./skill-submit-card.vue?vue&type=template&id=443d8028&scoped=true&"
import script from "./skill-submit-card.vue?vue&type=script&lang=js&"
export * from "./skill-submit-card.vue?vue&type=script&lang=js&"
import style0 from "./skill-submit-card.vue?vue&type=style&index=0&id=443d8028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d8028",
  null
  
)

export default component.exports